import { render, staticRenderFns } from "./WorkspacePanel.vue?vue&type=template&id=2cfd52c5&scoped=true"
import script from "./WorkspacePanel.vue?vue&type=script&lang=js"
export * from "./WorkspacePanel.vue?vue&type=script&lang=js"
import style0 from "./WorkspacePanel.vue?vue&type=style&index=0&id=2cfd52c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfd52c5",
  null
  
)

export default component.exports